<template>
	<button
		:class="{
			'btn-active': active,
			'btn-has-text': hasText,
			'btn-greyed': greyed,
		}"
	>
		<svg
			width="20"
			viewBox="0 0 52 52"
			fill="transparent"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				stroke-width="3"
				class="icon-plus-circle"
				cx="26"
				cy="26"
				r="22.5"
				stroke="#999999"
			/>
			<path
				class="icon-plus-minus"
				d="M14.625 24.375C13.7933 24.375 13 25.1683 13 26C13 26.8317 13.7933 27.625 14.625 27.625H37.375C38.2067 27.625 39 26.8317 39 26C39 25.1683 38.2067 24.375 37.375 24.375H14.625Z"
				fill="#999999"
			/>
			<path
				class="icon-plus-plus"
				d="M24.375 14.625V24.375H14.625C13.7933 24.375 13 25.1683 13 26C13 26.8317 13.7933 27.625 14.625 27.625H24.375V37.375C24.375 38.2067 25.1683 39 26 39C26.8317 39 27.625 38.2067 27.625 37.375V27.625H37.375C38.2067 27.625 39 26.8317 39 26C39 25.1683 38.2067 24.375 37.375 24.375H27.625V14.625C27.625 13.7933 26.823 13 26 13C25.177 13 24.375 13.7933 24.375 14.625Z"
				fill="#999999"
			/>
		</svg>

		<span
			v-if="hasText"
			class="text-slot"
		>
			<slot name="default" />
		</span>
	</button>
</template>

<script lang="ts">
import { defineComponent, type SlotsType } from 'vue';

export default defineComponent({
	slots: Object as SlotsType<{
		default: null;
	}>,
	props: {
		active: {
			type: Boolean,
			default: false,
		},
		greyed: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		hasText() {
			return !!this.$slots.default;
		},
	},
});
</script>

<style scoped lang="scss">
button {
	.text-slot {
		margin-left: 4px;
	}

	&.btn-has-text {
		svg {
			margin-left: -24px;
		}
	}

	&:hover {
		.icon-plus-circle {
			fill: rgb(var(--rs-color-brand-tomato));
			stroke: rgb(var(--rs-color-brand-tomato));
		}

		.icon-plus-minus {
			fill: white;
		}
	}

	&:not(.btn-active) {
		&:hover {
			svg {
				.icon-plus-circle {
					stroke: rgb(var(--rs-color-brand-honey));
					fill: rgb(var(--rs-color-brand-honey));
				}

				.icon-plus-plus {
					fill: white;
				}
			}
		}
	}

	&.btn-active {
		&:not(.btn-greyed) {
			svg {
				.icon-plus-circle {
					stroke: rgb(var(--rs-color-brand-honey));
					fill: rgb(var(--rs-color-brand-honey));
				}

				.icon-plus-minus {
					fill: white;
				}
			}
		}

		svg {
			.icon-plus-plus {
				opacity: 0;
			}
		}

		&:hover {
			svg {
				.icon-plus-circle {
					stroke: rgb(var(--rs-color-brand-tomato));
					fill: rgb(var(--rs-color-brand-tomato));
				}

				.icon-plus-minus {
					fill: white;
				}

				.icon-plus-plus {
					opacity: 0;
				}
			}
		}
	}

	&.btn-greyed {
		color: rgb(var(--rs-color-brand-grey-text));
	}
}
</style>
